import { Button, EmptyState } from "@components";
import { Plus } from "@untitledui/icons";

type VehicleDocumentEmptyProps = {
	title: string;
	description: string;
	onAdd: () => void;
	buttonText: string;
};
export const VehicleDocumentEmpty = ({
	title,
	description,
	onAdd,
	buttonText,
}: VehicleDocumentEmptyProps) => (
	<EmptyState className="my-10 max-w-[352px]">
		<EmptyState.Illustration
			className="h-[180px] w-[175px]"
			size="sm"
			type="documents"
		/>
		<div className="flex flex-col items-center gap-6">
			<div className="flex flex-col items-center gap-2">
				<EmptyState.Title className="font-semibold text-md text-primary leading-6">
					{title}
				</EmptyState.Title>
				<EmptyState.Description className="text-center text-sm text-tertiary leading-5">
					{description}
				</EmptyState.Description>
			</div>
			<Button className="w-fit" onClick={onAdd} size="lg">
				<Plus className="size-5" color="#84CAFF" />
				{buttonText}
			</Button>
		</div>
	</EmptyState>
);
